import "./polyfills";
import "./main";
